import React, { FunctionComponent } from "react"
import { Modal } from "react-bootstrap"
import LDSEllipsis from "src/components/common/LDS/LDSEllipsis/LDSEllipsis"
import "./DynamicFormsRefreshing.css"



const DynamicFormsRefreshing: FunctionComponent<{}> = () => {
    return (
        <div className="DynamicFormsRefreshing">
            <Modal
                id="dynamic-forms-refreshing-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
            >
                <Modal.Header>
                    <div className="DynamicFormsRefreshingModalHeader">
                        <span className="material-icons">dynamic_feed</span>
                        <p>Refreshing form data...</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="DynamicFormsRefreshingModalBody">
                        <LDSEllipsis />
                    </div>
                </Modal.Body>

            </Modal>
        </div>
    )
}

export default DynamicFormsRefreshing